/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Hero_HighlightInputs */

const en_nfp_hero_highlight = /** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building Stronger Communities.`)
};

const es_nfp_hero_highlight = /** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construyendo Comunidades Más Fuertes.`)
};

const fr_nfp_hero_highlight = /** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bâtir des communautés plus fortes.`)
};

const de_nfp_hero_highlight = /** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stärkere Gemeinschaften aufbauen.`)
};

const id_nfp_hero_highlight = /** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membangun Komunitas yang Lebih Kuat.`)
};

/** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */
const ja_nfp_hero_highlight = en_nfp_hero_highlight;

/** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */
const zh_nfp_hero_highlight = en_nfp_hero_highlight;

/** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */
const ar_nfp_hero_highlight = en_nfp_hero_highlight;

/** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */
const it_nfp_hero_highlight = en_nfp_hero_highlight;

/** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */
const ru_nfp_hero_highlight = en_nfp_hero_highlight;

/** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */
const pt_nfp_hero_highlight = en_nfp_hero_highlight;

/** @type {(inputs: Nfp_Hero_HighlightInputs) => LocalizedString} */
const ko_nfp_hero_highlight = en_nfp_hero_highlight;

/**
* | output |
* | --- |
* | "Building Stronger Communities." |
*
* @param {Nfp_Hero_HighlightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_hero_highlight = /** @type {((inputs?: Nfp_Hero_HighlightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Hero_HighlightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_hero_highlight(inputs)
	if (locale === "es") return es_nfp_hero_highlight(inputs)
	if (locale === "fr") return fr_nfp_hero_highlight(inputs)
	if (locale === "de") return de_nfp_hero_highlight(inputs)
	if (locale === "ja") return ja_nfp_hero_highlight(inputs)
	if (locale === "zh") return zh_nfp_hero_highlight(inputs)
	if (locale === "ar") return ar_nfp_hero_highlight(inputs)
	if (locale === "id") return id_nfp_hero_highlight(inputs)
	if (locale === "it") return it_nfp_hero_highlight(inputs)
	if (locale === "ru") return ru_nfp_hero_highlight(inputs)
	if (locale === "pt") return pt_nfp_hero_highlight(inputs)
	return ko_nfp_hero_highlight(inputs)
});